import { ErhlEquityAccessMethod, ErhlLoanPurpose } from '@/helpers/const';
import { yupArray, yupObject, yupString } from '../../yup';

/** Description is required only when 'Other' is among the selected purposes */
const isDescriptionRequired = (purposes?: string[]) =>
  Array.isArray(purposes) && purposes.includes(ErhlLoanPurpose.OTHER);

export const erhlLoanPurposeSchema = yupObject({
  erhlLoanPurposes: yupArray(yupString().required())
    .min(1, 'Please select at least one loan purpose')
    .required()
    .label('Loan purpose'),

  erhlLoanPurposeOtherDescription: yupString().when('erhlLoanPurposes', ([purposes], schema) =>
    isDescriptionRequired(purposes) ? schema.required().label('More details on the loan purpose') : schema.optional(),
  ),
  erhlEquityAccessMethod: yupString()
    .oneOf(Object.values(ErhlEquityAccessMethod))
    .required('Selection is required')
    .label('Equity access method'),
});
